/**
 * @license
 * @preserve
 *
 * KeeeX SAS Confidential
 * https://keeex.me
 * Copyright 2013-2023 KeeeX All Rights Reserved.
 * 
 * These computer program listings and specifications, herein,
 * are and remain the property of KeeeX SAS. The intellectual
 * and technical concepts herein are proprietary to KeeeX SAS
 * and may be covered by EU and foreign patents,
 * patents in process, trade secrets and copyright law.
 * 
 * They shall not be reproduced or copied or used in whole or
 * in part as the basis for manufacture or sale of items unless
 * prior written permission is obtained from KeeeX SAS.
 * 
 * For a license agreement, please contact:
 * <mailto: contact@keeex.net>
 * 
 */
import{asArray as e}from"@keeex/js-utils/lib/array.js";import{Bundle as t}from"@keeex/js-keys/lib/bundle.js";import{importKey as a}from"@keeex/js-keys/lib/keys.js";import{KeyType as s}from"@keeex/js-keys/lib/shared/types.js";import{buf82utf8 as r,utf82buf8 as n}from"@keeex/js-utils/lib/uint8array.js";export const createKeyBundle=async(e,a)=>{const s=await e.exportKey(!1,{type:"json"}),r=[e,a];return(await t.createBundle(r,n(s))).saveBundle()};const o=async(e,t)=>{try{return await e.getData(t),!0}catch{return!1}};export const extendBundle=async(a,s,r)=>{const n=await t.loadBundle(a);for(const t of e(r))await o(n,t)||await n.addRecipient(t,s);return n.saveBundle()};export const loadDataBundle=async(e,n)=>{const o=await t.loadBundle(e);return a(s.bitcoin,{type:"json",value:r(await o.getData(n))})};